/** returns payments list
@return { Array }
*/
export const getPaymentsList = state => {
    return state.paymentsList
}

/** returns payments hasMore value
@return { Boolean }
*/
export const getPaymentsHasMore = state => {
    return state.paymentsHasMore
}

/** returns channels list
@return { Array }
*/
export const getChannelsList = state => state.channelsList

/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}

/** returns payments status list
@return { Array }
*/
export const getPaymentsStatusList = state => {
    return state.paymentsStatusList
}
